import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Paper, Box, Typography, LinearProgress, Chip, Table, TableHead,
  TableBody, TableRow, TableCell, Collapse, Button,
} from "@mui/material";
import { API_URL } from "../config";

const SUBJECT_LABEL = { DS: "DS学", MD1: "MD1", MD2: "MD2", SI: "ソーシャルイノベーション" };

function rateColor(rate) {
  if (rate == null) return "success";
  if (rate < 40) return "error";
  if (rate < 70) return "warning";
  return "success";
}

// 学生本人の課題提出状況カード（/me/at-risk）。名簿外なら何も表示しない。
export default function MyProgress() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/me/at-risk`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((r) => setData(r.data))
      .catch(() => setData({ matched: false }));
  }, []);

  if (!data || !data.matched || !data.student) return null;
  const s = data.student;
  const rate = s.submit_rate;

  return (
    <Paper sx={{ p: 2, mb: 3, border: "1px solid", borderColor: rate != null && rate < 70 ? "warning.main" : "grey.800" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6">📋 あなたの課題提出状況</Typography>
        <Button size="small" onClick={() => setOpen(!open)}>{open ? "隠す" : "表示"}</Button>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
        <Chip
          label={rate == null ? "標準課題 提出率 —" : `標準課題 提出率 ${rate}%`}
          color={rateColor(rate)}
        />
        <Typography variant="body2">
          標準課題 提出 {s.std_turned}/{s.std_total}・遅延 {s.late}
        </Typography>
      </Box>
      {rate != null && (
        <LinearProgress variant="determinate" value={rate} color={rateColor(rate)}
          sx={{ mt: 1, height: 8, borderRadius: 1 }} />
      )}
      {s.not_in_classroom?.length > 0 && (
        <Typography variant="body2" sx={{ mt: 1, color: "error.light", fontWeight: "bold" }}>
          🚨 {s.not_in_classroom.join("・")} の Google Classroom に参加していません。至急クラスコードで参加してください。
        </Typography>
      )}
      {s.d_risk && (
        <Typography variant="body2" sx={{ mt: 1, color: "error.light", fontWeight: "bold" }}>
          ⚠️ {s.d_risk_subjects.join("・")} は標準課題の提出が1/3以下です。このままだとD評価の可能性があります。至急提出してください。
        </Typography>
      )}
      {!s.d_risk && s.missing > 0 && (
        <Typography variant="body2" sx={{ mt: 1, color: "warning.light" }}>
          未提出の課題があります。締切を確認しましょう。
        </Typography>
      )}
      <Collapse in={open}>
        <Table size="small" sx={{ mt: 1 }}>
          <TableHead>
            <TableRow>
              <TableCell>科目</TableCell><TableCell align="center">標準 提出</TableCell>
              <TableCell align="center">未提出</TableCell><TableCell align="center">遅延</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {["DS", "MD1", "MD2", "SI"].map((k) => {
              if (!s.enrolled?.[k]) return null;
              const d = s.by_subject?.[k];
              const isMD = k === "MD1" || k === "MD2";
              const num = d ? (isMD ? d.std_turned : d.turned_in) : 0;
              const den = d ? (isMD ? d.std_total : d.total) : 0;
              const dRiskHere = s.d_risk_subjects?.includes(k);
              return (
                <TableRow key={k}>
                  <TableCell>
                    {SUBJECT_LABEL[k]}
                    {dRiskHere && <Chip size="small" color="error" label="D" sx={{ ml: 0.5 }} />}
                  </TableCell>
                  <TableCell align="center">
                    {d ? `${num}/${den}` : <span style={{ color: "#e53935", fontWeight: "bold" }}>未参加</span>}
                  </TableCell>
                  <TableCell align="center" sx={{ color: d && d.missing > 0 ? "#ff7043" : "inherit" }}>
                    {d ? d.missing : "—"}
                  </TableCell>
                  <TableCell align="center">{d ? d.late : "—"}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Collapse>
    </Paper>
  );
}
